module.exports = __webpack_public_path__ + "static/hero-0bcb02a4613488e845a858a59ebb7e2f.jpg";